module.exports = __webpack_public_path__ + "static/media/paris-grenoble.04047d64.png";